import Form from './form'
import MultiStepWrapper from '../../helpers/multi-step'

const MultiStepForm = props => (
  <MultiStepWrapper totalSteps={props?.schema?.steps?.length} {...props}>
    <Form />
  </MultiStepWrapper>
)

export default MultiStepForm
